import { assign, literal, nullable, object, string } from "superstruct";

import InstagramPostBaseMediaSchema from "./InstagramPostBaseMediaSchema";

const InstagramPostVideoMediaSchema = assign(
    InstagramPostBaseMediaSchema,
    object({
        type: literal("video"),
        videoUrl: nullable(string()),
    })
);

export default InstagramPostVideoMediaSchema;
